import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20134d2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reporting-main" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Timesheet Approval", -1))
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_5 = {
  key: 0,
  class: "fal fa-angle-up"
}
const _hoisted_6 = {
  key: 1,
  class: "fal fa-angle-down"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "seperator" }, null, -1))
const _hoisted_8 = { class: "filter" }
const _hoisted_9 = { class: "form-col" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Practice name", -1))
const _hoisted_11 = { class: "sml-select" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-col" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Activity type", -1))
const _hoisted_16 = { class: "sml-select" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "form-col" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Investigator", -1))
const _hoisted_21 = { class: "sml-select" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "form-col" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Supervisor", -1))
const _hoisted_26 = { class: "sml-select" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "form-col" }
const _hoisted_30 = {
  key: 0,
  class: "reset-filter"
}
const _hoisted_31 = {
  class: "bottom-half",
  style: {"width":"100%","overflow":"auto"}
}
const _hoisted_32 = { class: "approval-list-items" }
const _hoisted_33 = { class: "approval-list-heading" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Investigator stats", -1))
const _hoisted_35 = {
  key: 0,
  class: "fal fa-exclamation-triangle fa-lg mr-2"
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { class: "hide-button" }
const _hoisted_39 = {
  key: 0,
  class: "fal fa-angle-up"
}
const _hoisted_40 = {
  key: 1,
  class: "fal fa-angle-down"
}
const _hoisted_41 = { class: "timesheet-approval-table" }
const _hoisted_42 = { class: "ls-table" }
const _hoisted_43 = { "data-label": "Investigator" }
const _hoisted_44 = { "data-label": "Complete time" }
const _hoisted_45 = { "data-label": "Missing time" }
const _hoisted_46 = {
  key: 0,
  class: "ml-2 warning fal fa-exclamation-triangle fa-lg"
}
const _hoisted_47 = { "data-label": "Annual/Personal Leave" }
const _hoisted_48 = { "data-label": "Public holidays" }
const _hoisted_49 = {
  class: "actions",
  "data-label": "Actions"
}
const _hoisted_50 = { class: "approved mr-2" }
const _hoisted_51 = {
  key: 0,
  class: "approved-label"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Approved", -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "resolve-label"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Resolve underclaimed hours", -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  key: 2,
  class: "approve-button"
}
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "timesheet-table mt-2" }
const _hoisted_61 = { class: "ls-table" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = ["colspan"]
const _hoisted_64 = { key: 1 }
const _hoisted_65 = ["colspan"]
const _hoisted_66 = { key: 2 }
const _hoisted_67 = ["colspan"]
const _hoisted_68 = { "data-label": "Date" }
const _hoisted_69 = { "data-label": "Investigator" }
const _hoisted_70 = { "data-label": "Name" }
const _hoisted_71 = { "data-label": "Details" }
const _hoisted_72 = { "data-label": "Practice name" }
const _hoisted_73 = { "data-label": "Reference" }
const _hoisted_74 = { "data-label": "Break" }
const _hoisted_75 = { "data-label": "Work hours" }
const _hoisted_76 = { "data-label": "Actions" }
const _hoisted_77 = ["disabled", "onClick"]

export function render(_ctx, _cache) {
  const _component_DateController = _resolveComponent("DateController")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DateController, {
          style: {"min-width":"550px"},
          onGetTimePeriod: _ctx.getTimePeriod,
          onPrev: _ctx.prev,
          onNext: _ctx.next,
          onToday: _ctx.today,
          onUpdate: _ctx.updateDisplay
        }, null, 8, ["onGetTimePeriod", "onPrev", "onNext", "onToday", "onUpdate"]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn btn-default mr-2",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showHideAdvFilter && _ctx.showHideAdvFilter(...args)))
          }, [
            _createElementVNode("span", null, [
              _createTextVNode("Advanced Filter "),
              (_ctx.showAdvFilter)
                ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                : (_openBlock(), _createElementBlock("i", _hoisted_6))
            ])
          ])
        ])
      ]),
      (_ctx.showAdvFilter)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.filters.practiceName) = $event))
                  }, [
                    _hoisted_12,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practices, (p, idx) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: p.firmName
                      }, _toDisplayString(p.firmName), 9, _hoisted_13))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.practiceName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.filters.timeEntryActivityId) = $event))
                  }, [
                    _hoisted_17,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeEntryActivity, (i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.id
                      }, _toDisplayString(i.name), 9, _hoisted_18))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.timeEntryActivityId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.filters.trustTeamMemberId) = $event))
                  }, [
                    _hoisted_22,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigators, (i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.id
                      }, _toDisplayString(i.displayName), 9, _hoisted_23))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.trustTeamMemberId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.filters.supervisorId) = $event))
                  }, [
                    _hoisted_27,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supervisors, (i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.id
                      }, _toDisplayString(i.displayName), 9, _hoisted_28))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.supervisorId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  class: "btn btn-secondary sml",
                  onClick: _cache[5] || (_cache[5] = $event => (_ctx.applyFilter()))
                }, " Apply filter ")
              ])
            ]),
            (_ctx.filterApplied)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createTextVNode(" Or "),
                  _createElementVNode("a", {
                    class: "link2",
                    onClick: _cache[6] || (_cache[6] = $event => {_ctx.resetFilter();})
                  }, "reset all")
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", {
        class: _normalizeClass(["approval-list", _ctx.investigatorsWithUnderclaimedHours === 0 ? 'timesheet-approved' : 'timesheet-not-approved'])
      }, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("span", null, [
              (_ctx.investigatorsWithUnderclaimedHours !== 0)
                ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                : _createCommentVNode("", true),
              (_ctx.investigatorsWithUnderclaimedHours === 0)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_36, "No underclaimed hours, no leave upcoming"))
                : (_openBlock(), _createElementBlock("h4", _hoisted_37, _toDisplayString(_ctx.investigatorsWithUnderclaimedHours) + " Investigators with underclaimed hours", 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("button", {
              class: "btn btn-secondary sml mr-2",
              onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.showHideTSApproval && _ctx.showHideTSApproval(...args)))
            }, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.showTimesheetApproval ? 'Hide' : 'Show'), 1),
                (_ctx.showTimesheetApproval)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_39))
                  : (_openBlock(), _createElementBlock("i", _hoisted_40))
              ])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_41, [
          _createElementVNode("table", _hoisted_42, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timesheetApprovalHeadings, (h, index) => {
                  return (_openBlock(), _createElementBlock("th", null, [
                    _createElementVNode("p", null, _toDisplayString(h.text), 1)
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTimesheetApprovals, (t) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", _hoisted_43, _toDisplayString(t.trustTeamMember.displayName), 1),
                  _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.$calculateHours(t.completeTime)), 1),
                  _createElementVNode("td", _hoisted_45, [
                    _createTextVNode(_toDisplayString(_ctx.$calculateHours(t.missingTime)) + " ", 1),
                    (!t.missingTime/60 === 0)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_46))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.$calculateHours(t.annualLeaveTime + t.personalLeaveTime)), 1),
                  _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.$calculateHours(t.publicHolidayTime)), 1),
                  _createElementVNode("td", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      (t.timesheetStatus?.id === 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, _hoisted_53))
                        : _createCommentVNode("", true),
                      (t.timesheetStatus?.id === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, _hoisted_56))
                        : _createCommentVNode("", true),
                      (t.timesheetStatus?.id === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, [
                            _createElementVNode("button", {
                              class: "btn btn-default sml ma-1",
                              onClick: $event => (_ctx.approveTimeEntries(t.trustTeamMember))
                            }, "Approve", 8, _hoisted_58)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-default sml ma-1",
                      onClick: $event => (_ctx.viewInvestigator(t.trustTeamMember))
                    }, "View", 8, _hoisted_59)
                  ])
                ]))
              }), 256))
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showTimesheetApproval]
        ])
      ], 2),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("table", _hoisted_61, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timesheetEntryHeadings, (h, index) => {
                return (_openBlock(), _createElementBlock("th", null, [
                  _createElementVNode("p", null, _toDisplayString(h.text), 1)
                ]))
              }), 256))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.loadingTimeEntries)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_62, [
                  _createElementVNode("td", {
                    colspan: _ctx.timesheetEntryHeadings.length
                  }, [
                    _createVNode(_component_LoadingIndicator)
                  ], 8, _hoisted_63)
                ]))
              : (_ctx.errorLoadingTimeEntries)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_64, [
                    _createElementVNode("td", {
                      colspan: _ctx.timesheetEntryHeadings.length
                    }, [
                      _createVNode(_component_ErrorIndicator)
                    ], 8, _hoisted_65)
                  ]))
                : (!_ctx.loadingTimeEntries && !_ctx.errorLoadingTimeEntries && _ctx.filterTimeSheetEntries.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_66, [
                      _createElementVNode("td", {
                        colspan: _ctx.filterTimeSheetEntries.length
                      }, "No Records", 8, _hoisted_67)
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.filterTimeSheetEntries, (t) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.$formatDateTimeTypeA(t.startDateTime)) + " - " + _toDisplayString(_ctx.$formatDateTimeTypeA(t.endDateTime)), 1),
                        _createElementVNode("td", _hoisted_69, [
                          _createVNode(_component_router_link, {
                            to: {name: _ctx.RouteN.TA.InvestigatorDashboard.n, query: { memberId: t.trustTeamMember.id } },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(t.trustTeamMember.displayName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.$getTimeEntryTypeName(t.timeEntryType.id, _ctx.timeEntryType)), 1),
                        _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.$getDetails(t)), 1),
                        _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.$getFirmName(t)), 1),
                        _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.$getReference(t)), 1),
                        _createElementVNode("td", _hoisted_74, _toDisplayString(_ctx.$getBreakHours(t)), 1),
                        _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.$getWorkHours(t)), 1),
                        _createElementVNode("td", _hoisted_76, [
                          _createElementVNode("button", {
                            class: "btn btn-default sml ma-1",
                            disabled: _ctx.$getFirmName(t) == null,
                            onClick: $event => (_ctx.editTimesheet(t))
                          }, "View event", 8, _hoisted_77)
                        ])
                      ]))
                    }), 256))
          ])
        ])
      ])
    ])
  ]))
}